import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const settingDetailsApi = createAsyncThunk(
    'auth/setting/details',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.adminAction(`passing-criteria-details/${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const settingDetailsSlice = createSlice({
    name: 'setting details',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetsetting: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(settingDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(settingDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(settingDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetsetting } = settingDetailsSlice.actions;
export const settingDetailsReducer = settingDetailsSlice.reducer